import { Modal } from "@material-ui/core";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import styled from "styled-components";
import Button from "../Button";
import TextView from "../TextView";

export const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const DialogContainer = styled.div`
  background-color: white;
  width: 90vw;
  max-width: 400px;
  margin: auto;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow-y: auto;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
`;

export const StyledIconButton = styled(IconButton)`
  color: #123051;
  padding: 4px;
`;

export const ContentWrapper = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const WheelContainer = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
`;

export const IconOverlay = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  background-color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  border: 2px solid ${(props) => props.borderColor || "#ff6b35"};
`;

export const EmailInput = styled(TextField)`
  width: 100%;

  & .MuiOutlinedInput-root {
    border-radius: 8px;
    height: 45px;

    & fieldset {
      border-color: ${(props) => (props.error ? "#FF3933" : "#dfe2e6")};
      border-width: 1px;
    }

    &:hover fieldset {
      border-color: ${(props) => (props.error ? "#FF3933" : "#dfe2e6")};
    }

    &.Mui-focused fieldset {
      border-color: ${(props) => (props.error ? "#FF3933" : "#9b5af8")};
    }
  }

  & .MuiOutlinedInput-input {
    padding: 12px;
    font-family: "DM Sans", sans-serif;
    font-size: 14px;

    &::placeholder {
      color: #999999;
      opacity: 1;
    }
  }
`;

export const ErrorText = styled(Typography)`
  color: #ff3933;
  font-size: 15px;
  text-align: left;
  margin-top: 4px;
  font-family: "DM Sans", sans-serif;
`;

export const TitleText = styled(TextView)`
  text-align: center;
  margin-top: 8px;
  font-size: 20px;
  line-height: 24px;
`;

export const DescriptionText = styled(TextView)`
  text-align: center;
  font-size: 15px;
  line-height: 20px;
`;

export const DescriptionTextWithMargin = styled(TextView)`
  text-align: center;
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 16px;
`;

export const ContinueBrowserText = styled(TextView)`
  text-align: center;
  font-size: 14px;
  line-height: 20px;
`;

export const ContinueBrowserTextWithMargin = styled(TextView)`
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
`;

export const AppStoreButton = styled(Button)`
  background-color: #181819;
  gap: 8px;
  text-transform: none;
  height: 48px;
  margin-top: 8px;
`;

export const SubmitButton = styled(Button)`
  background-color: #181819;
  color: white;
`;

export const CancelButton = styled(Button)`
  flex: 1;
`;

export const LoginButton = styled(Button)`
  flex: 1;
  background-color: #9b5af8;
  color: white;
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const EmailFormContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EmailFormButtonsContainer = styled(Box)`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const AppIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const StyledIconComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  & > svg,
  & > * {
    color: ${(props) => props.color} !important;
    font-size: 18px !important;
  }
`;

